    document.addEventListener('DOMContentLoaded', function () {
    const viewports = document.querySelectorAll('.brand-slider-track-viewport');

    viewports.forEach(viewport => {
        const track = viewport.querySelector('.brand-slider-track');
        if (!track) return;

        let isDown = false;
        let startX;
        let scrollLeft;

        const startSwipe = (e) => {
        isDown = true;
        viewport.classList.add('is-swiping');
        startX = (e.pageX || e.touches[0].pageX) - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        };

        const stopSwipe = () => {
        if (!isDown) return;
        isDown = false;
        viewport.classList.remove('is-swiping');
        
        const segmentWidth = track.scrollWidth / 3;
        if (track.scrollLeft >= segmentWidth * 2) {
            track.scrollLeft -= segmentWidth;
        } else if (track.scrollLeft <= 0) {
            track.scrollLeft += segmentWidth;
        }
        };

        const moveSwipe = (e) => {
        if (!isDown) return;
        const x = (e.pageX || e.touches[0].pageX) - track.offsetLeft;
        const walk = (x - startX) * 1.2;
        track.scrollLeft = scrollLeft - walk;
        };

        track.addEventListener('mousedown', startSwipe);
        track.addEventListener('mouseleave', stopSwipe);
        track.addEventListener('mouseup', stopSwipe);
        track.addEventListener('mousemove', moveSwipe);

        track.addEventListener('touchstart', startSwipe, { passive: true });
        track.addEventListener('touchend', stopSwipe, { passive: true });
        track.addEventListener('touchmove', moveSwipe, { passive: true });
    });
    });